import { useCallback } from 'react';
import { handleAxiosError, message } from 'ui';
import { isDefaultResponseErrorDataObject } from 'common/services';
import { useUser } from 'features/auth';
import { useEnterBigMarker } from '../queries';
import { isJoinPeriod, parseBigmarkerErrorMessage } from '../utils';
import type { ProgramEventData } from './useEventActions';

export const useOnRequestEnterConference = () => {
  const { isPending: isJoining, mutate: enterBigMarkerConference } = useEnterBigMarker();
  const {
    railsUserData: { id },
  } = useUser();

  const onRequestEnterConference = useCallback(
    (event: ProgramEventData) => {
      if (isJoinPeriod(event)) {
        enterBigMarkerConference(
          {
            eventId: event.id,
            exitUrl: `${window.location.href}?feedback=true&eventId=${event.id}`,
            userIds: [id],
          },
          {
            onError(error) {
              handleAxiosError(
                error,

                parseBigmarkerErrorMessage({
                  errorMessage: isDefaultResponseErrorDataObject(error.response?.data)
                    ? error.response.data.message
                    : '',
                }),
              );
            },
            onSuccess(data) {
              window.open(data.enterUri, '_self');
            },
          },
        );
      } else {
        message.warn('This video conference is already over');
      }
    },
    [enterBigMarkerConference, id],
  );

  return { isJoining, onRequestEnterConference };
};
